module.exports = __webpack_public_path__ + "static/media/manu-5.c5741429.png";